// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__3sIOc","label":"CategoryService_label__X97oG","location":"CategoryService_location__1bGT1"};